import { makeActionCreator } from '../../config/store/utils'
import { getBuyingModalities } from '../../services/charts'

export const BUYINGMODALITIES = 'BUYINGMODALITIES'
export const BUYINGMODALITIES_ERROR = 'BUYINGMODALITIES_ERROR'
export const BUYINGMODALITIES_SUCCESS = 'BUYINGMODALITIES_SUCCESS'
export const onBuyingModalities = makeActionCreator(BUYINGMODALITIES)
export const onBuyingModalitiesError = makeActionCreator(BUYINGMODALITIES_ERROR, 'payload')
export const onBuyingModalitiesSuccess = makeActionCreator(BUYINGMODALITIES_SUCCESS, 'payload')
export const onBuyingModalitiesThunk = (idEntity, year) => async dispatch => {
  dispatch(onBuyingModalities())

  try {
    const { data } = await getBuyingModalities({ idEntity, year })

    if (data.success !== 'OK') {
      return dispatch(onBuyingModalitiesError(data.errores))
    }

    const singleObj = data.payload.find(item => item.year === year)
    const chartData = singleObj.data.map(item => ({ ...item, y: item.amount }))
    const csvData = [
      ['Mecanismo de compra', 'N° de órdenes de compra', 'Monto total (CLP)', 'Monto porcentual'],
      ...chartData.map(item => [item.name, item.orders, item.amount, item.percentage])
    ]
    const payload = { chartStructure: chartData, csvStructure: csvData }

    return dispatch(onBuyingModalitiesSuccess(payload))
  } catch (error) {
    return dispatch(onBuyingModalitiesError(error))
  }
}
